import { render } from "./d-good-road-panel.vue?vue&type=template&id=b9845a04&scoped=true&ts=true"
import script from "./d-good-road-panel.vue?vue&type=script&lang=ts"
export * from "./d-good-road-panel.vue?vue&type=script&lang=ts"

import "./d-good-road-panel.vue?vue&type=style&index=0&id=b9845a04&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9845a04"]])

export default __exports__